module.exports = __webpack_public_path__ + "static/Group 132-978cf7c3a3aac35674fb4a4738f19d20.png";